module.exports = __webpack_public_path__ + "static/media/navigateBackIcon.1a1e6a4e.svg";